import template		from "./view-overview.html";
import css			from "./view-overview.css";

import Page			from "../view-page.js";

export default class OverviewView extends Page {  
  static get template() {
    return template;
  }
  
  static get css() {
    return css;
  }

  #onupdatedevices_handler;
  #onupdatefermentations_handler;
    
  static {
    customElements.define("fulljs-view-overview", OverviewView);
  }

  async connectedCallback(...args) {
    await super.connectedCallback(...args);

    const response = await fetch("/page/overview/hmi.svg", {
      method: "GET",
      headers: {
        "Accept": "image/svg+xml"
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to load overview.svg: ${response.statusText}`);
    }

    const svgText = await response.text();

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgText, "image/svg+xml");

    const svgElement = svgDoc.documentElement;

    this.appendChild(svgElement);
    
    //add event listeners
    document.addEventListener(
      "onupdatedevices",
      this.#onupdatedevices_handler
    );

    document.addEventListener(
      "onupdatefermentations",
      this.#onupdatefermentations_handler
    );    
  }

  async disconnectedCallback(...args) {
    await super.disconnectedCallback(...args);
    
    document.removeEventListener(
      "onupdatedevices",
      this.#onupdatedevices_handler
    );

    document.removeEventListener(
      "onupdatefermentations",
      this.#onupdatefermentations_handler
    );    
  }

  constructor(...args) {
    super(...args);   
    
    this.#onupdatedevices_handler =
      this.onupdatedevices_handler.bind(this);

    this.#onupdatefermentations_handler =
      this.onupdatefermentations_handler.bind(this);    
  }

  async onupdatedevices_handler(event) {
    let devices = event.detail;

    devices = Object.values(devices).map(obj => ({ ...obj }));

    for (const device of devices) {
      const name = device.name;

      const text = this.querySelector(`text[data-name="${name}"]`);

      if (!text) {
        continue;
      }

      const value = device[text.dataset.value];

      // Find or create tspan
      let tspan = text.querySelector("tspan");

      if (!tspan) {
        tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        text.appendChild(tspan);
      }

      tspan.textContent = value;
    }
  }

  onupdatefermentations_handler(event) {
    console.log("fermentations updated", event);
  }
}